import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMembershipGoldColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 259 259" {...props}>
      <path
        fill="url(#membership_gold_colored_svg__a)"
        stroke="#E6B423"
        strokeWidth={7}
        d="M99.692 15.847c16.463-16.463 43.153-16.463 59.616 0l2.899 2.9a35.15 35.15 0 0 0 24.857 10.295h.74c23.281 0 42.154 18.873 42.154 42.154v.74a35.15 35.15 0 0 0 10.296 24.857l2.899 2.9c16.463 16.462 16.463 43.152 0 59.615l-2.899 2.899a35.15 35.15 0 0 0-10.296 24.857v.74c0 23.281-18.873 42.154-42.154 42.154h-.74a35.15 35.15 0 0 0-24.857 10.296l-2.899 2.899c-16.463 16.463-43.153 16.463-59.616 0l-2.899-2.899a35.15 35.15 0 0 0-24.857-10.296h-.74c-23.28 0-42.154-18.873-42.154-42.154v-.74a35.15 35.15 0 0 0-10.296-24.857l-2.9-2.899c-16.462-16.463-16.462-43.153 0-59.616l2.9-2.899a35.15 35.15 0 0 0 10.296-24.857v-.74c0-23.28 18.873-42.154 42.154-42.154h.74a35.15 35.15 0 0 0 24.857-10.296z"
      />
      <path
        fill="url(#membership_gold_colored_svg__b)"
        d="m71.338 99.84 55.058-31.023A6.3 6.3 0 0 1 129.5 68a6.3 6.3 0 0 1 3.104.817l55.058 31.024a6.5 6.5 0 0 1 2.024 1.788 6.7 6.7 0 0 1 1.141 2.475 6.75 6.75 0 0 1-.965 5.264l-55.061 81.782a6.5 6.5 0 0 1-2.308 2.094 6.31 6.31 0 0 1-5.986 0 6.5 6.5 0 0 1-2.308-2.094l-55.06-81.779a6.7 6.7 0 0 1-1.028-2.527 6.8 6.8 0 0 1 .062-2.737 6.7 6.7 0 0 1 1.141-2.475 6.5 6.5 0 0 1 2.024-1.788z"
      />
      <defs>
        <linearGradient
          id="membership_gold_colored_svg__a"
          x1={74.375}
          x2={129.5}
          y1={7}
          y2={252}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFBD6" />
          <stop offset={1} stopColor="#FFE191" />
        </linearGradient>
        <linearGradient
          id="membership_gold_colored_svg__b"
          x1={88.5}
          x2={131.257}
          y1={83.75}
          y2={193.314}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3711D" />
          <stop offset={1} stopColor="#F7C649" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMembershipGoldColored);
export default ForwardRef;
